import { render, staticRenderFns } from "./branchesAdd.vue?vue&type=template&id=a5e5c256&scoped=true&"
import script from "./branchesAdd.vue?vue&type=script&lang=js&"
export * from "./branchesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e5c256",
  null
  
)

export default component.exports